import 'assets/adtrace.min.js';

import { Injectable } from '@angular/core';
import { DeviceService } from '@app/core';
import { environment } from '@env/environment';
import { AppParametersService } from '../token/app-parameters.service';

declare var AdTrace: any;

@Injectable({
  providedIn: 'root'
})
export class AdtraceService {

  constructor(
    private readonly parametersService: AppParametersService,
    private readonly device: DeviceService) { }

  public Adtrace(amount) {
    let _enviroment;
    let tokenEvent1, tokenEvent2;
    if (environment.envName === 'production') {
      _enviroment = 'production';
      tokenEvent2 = 'gri3of';
      tokenEvent1 = 'b063on';
    }
    else {
      _enviroment = 'sandbox';
      tokenEvent2 = 'btluj6';
      tokenEvent1 = 'io9jdh';
    }
    let _adverstimentId = this.parametersService.adverstimentId;
    if (_adverstimentId) {
      let osname = this.device.isIOS() ? 'iOS' : 'Android';
      let _adtrace = new AdTrace({
        app_token: 'lrs85poj1e07',
        environment: _enviroment, //'production' or 'sandbox' in case you are testing SDK locally with your web app
        os_name: osname,
        device_ids: {
          gps_adid: _adverstimentId // each web app user needs to have unique identifier
        }
      });
      let _eventConfig = {
        event_token: tokenEvent1,
        revenue: amount,
        currency: 'IRR'
      };

      _adtrace.trackEvent(_eventConfig, function (result) {
        console.log(result);
      }, function (errorMsg, error) {
        console.log(errorMsg, error);
      });

      let _eventConfig_second = {
        event_token: tokenEvent2,
        revenue: amount,
        currency: 'IRR'
      };

      _adtrace.trackEvent(_eventConfig_second, function (result) {
        console.log(result);
      }, function (errorMsg, error) {
        console.log(errorMsg, error);
      });
    }
  }

  // @JavascriptInterface
  //   public void sendEventToAddTrace(String event_token) {
  //       Tracker.getInstance().sendEventToAddTrace(event_token);
}
